import { TextField } from "@mui/material";

interface Props {
    input: string;
    placeholder?: string;
    onChange: (input: string) => void;
}

export default function JSONInput({ input, onChange, placeholder }: Props) {
    const handleKeyDown = (event: any) => {
        if (event.key === "Tab") {
            event.preventDefault(); // Prevent the default tab action

            // Get the textarea element
            const textarea = event.target;

            // Get the current cursor position
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;

            // Update the value with the tab character
            const newValue = textarea.value.substring(0, start) + "\t" + textarea.value.substring(end);
            textarea.value = newValue;

            // Move the cursor to the right position
            textarea.selectionStart = textarea.selectionEnd = start + 1;

            // Trigger a synthetic event to update React's state if needed
            if (typeof textarea.onchange === "function") {
                textarea.onchange({ target: textarea });
            }
        }
    };

    return (
        <TextField
            variant="outlined"
            fullWidth
            multiline
            defaultValue={isValidJSON(input) ? JSON.stringify(JSON.parse(input), undefined, 2) : ""}
            placeholder={placeholder}
            onKeyDown={handleKeyDown}
            onChange={(e) => onChange(e.target.value)}
        />
    );
}

export function isValidJSON(input: string) {
    try {
        JSON.parse(input);
    } catch (e) {
        return false;
    }
    return true;
}
